export default __webpack_public_path__ + "static/home-plant-based-vanilla-choc-pop-1ca98885786883f9cfc39e4f792973b2.png";